import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { type BoardListStoreInstance } from '../../../services/board-list.store';
import { type BoardSidebarView } from '../../../types/board';
import { BOARD_VIEW_TITLES } from '../../library/boards-list/boards-list.component';

export type BoardsPanelNavigation = BoardSidebarView | 'folders';

type PickerView = Exclude<BoardSidebarView, 'search_results'>;

/** The sidebar's views, in its order. */
const PICKER_VIEWS: readonly PickerView[] = ['all', 'recent', 'flagged', 'followup', 'snoozed', 'templates', 'archived', 'deleted'];

/** The dynamic panel's view picker, including a dedicated folder collection. */
@Component({
  selector: 'app-boards-views-context-menu',
  templateUrl: './boards-views-context-menu.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContextMenuItemComponent],
})
export class BoardsViewsContextMenuComponent {
  /** Set by the opening directive on the created instance before first render (`ContextMenuDirective` assigns
   * component fields directly, so this cannot be a signal input). */
  public listStore: BoardListStoreInstance;

  public foldersOpen = false;
  public navigate?: (view: BoardsPanelNavigation) => void;

  protected select(view: BoardsPanelNavigation): void {
    if (this.navigate) { this.navigate(view); return; }
    if (view === 'folders') return;
    if (view === 'search_results') this.listStore.landOnSearchResults();
    else this.listStore.setView(view);
  }
  /** Excludes `search_results` — that one is offered separately, gated on a search actually being applied
   * (SBUX-988 review #5: this list used to offer it unconditionally, the mirror image of the sidebar once
   * hiding it unconditionally off `view`). */
  protected readonly views: readonly { readonly id: PickerView; readonly title: string }[] = PICKER_VIEWS.map((id) => ({
    id,
    title: BOARD_VIEW_TITLES[id],
  }));

}
